import { render } from "./Poster.vue?vue&type=template&id=ecdda7ac"
import script from "./Poster.vue?vue&type=script&lang=js"
export * from "./Poster.vue?vue&type=script&lang=js"

import "./Poster.vue?vue&type=style&index=0&id=ecdda7ac&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__